import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { AppVersionModal } from '../../../app-version-modal/AppVersionModal';
import { HelpDeskModal } from '../../../help-desk-modal/HelpDeskModal';

import { styles } from './app-container-helpers';
import { AppHeader } from '../app-header';
import SideNavigation from '../app-side-nav/SideNavigation';
import { TrialModal } from '../../../../core';
import { useServices } from '../../../../hooks';

export const AppContainer = (props: {
    children: React.ReactNode;
}): React.JSX.Element => {
    const { data, isLoading } = useServices();

    const [open, setOpen] = useState(true);
    const [appVersionModalOpen, setAppVersionModalOpen] =
        useState<boolean>(false);
    const [helpDeskModalOpen, setHelpDeskModalOpen] = useState<boolean>(false);
    const [trialModalOpen, setTrialModalOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!isLoading && data?.data.trial === true) {
            setTrialModalOpen(true);
        }
    }, [data, isLoading]);

    const handleDrawerToggle = (): void => {
        // Set a timeout to update the canvas dimensions when the app bar is closed or opened.
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 195); // Duration of the sidebar transition animation.
        setOpen((prevVal) => !prevVal);
    };

    const handleVersionModalOpen = (): void => {
        setAppVersionModalOpen(true);
    };

    const handleVersionModalClose = (): void => {
        setAppVersionModalOpen(false);
    };

    const handleHelpDeskModalOpen = (): void => {
        setHelpDeskModalOpen(true);
    };

    const handleHelpDeskModalClose = (): void => {
        setHelpDeskModalOpen(false);
    };

    const handleTrialModalClose = (): void => {
        setTrialModalOpen(false);
    };

    return (
        <Box sx={styles.appHeaderContainer}>
            <SideNavigation
                handleDrawerToggle={handleDrawerToggle}
                onVersionModalOpen={handleVersionModalOpen}
                onHelpDeskModalOpen={handleHelpDeskModalOpen}
            />
            {/* main content */}
            <Box component='main' sx={styles.mainContentContainer(open)}>
                <AppHeader open={open} />
                <Box sx={styles.mainContent}>{props.children}</Box>
            </Box>
            {appVersionModalOpen && (
                <AppVersionModal onClose={handleVersionModalClose} />
            )}
            {helpDeskModalOpen && (
                <HelpDeskModal onClose={handleHelpDeskModalClose} />
            )}
            {trialModalOpen && <TrialModal onClose={handleTrialModalClose} />}
        </Box>
    );
};
